import { RadioButton } from 'src/modules/common/components/Radio/RadioButton.tsx';
import { I18n } from 'src/modules/common/components/I18n/I18n.tsx';
import { FlowUnitsOptions } from 'src/sensors/FlowUnitsRadioButtons/FlowUnitsOptions.ts';

type Props = {
    attribute: string;
    checked: string;
    onChange: (value: string) => void;
}

export const FlowUnitsRadioButtons = ({
    checked,
    onChange,
    attribute,
}: Props) => (
    <div className="vss-sensors-flow-range-radio-buttons">
        {FlowUnitsOptions.map(([value, label]) => (
            <RadioButton
                key={`flowUnits${attribute}${value}`}
                name={`flowUnit${attribute}`}
                id={`flowUnits${attribute}${value}`}
                value={value}
                checked={value === checked}
                onChange={() => onChange(value)}
            ><I18n messageId={label}/>
            </RadioButton>
        ))}
    </div>
);
